/**
 * Annual Breakdown Row Component
 * Card-style component showing tax year summary data
 */
import React from 'react';
import { Badge } from '../../components/ui/badge';
import { Calendar, Ship, TrendingUp } from 'lucide-react';

const AnnualBreakdownRow = ({ yearData, onSelect }) => {
  const { taxYear, totalEarnings, monthsWithEarnings, tripCount } = yearData;

  return (
    <div
      className="border border-slate-700 rounded-lg overflow-hidden cursor-pointer hover:border-amber-500/60 hover:bg-slate-700/30 transition-all border-l-4 border-l-amber-500/50"
      onClick={() => onSelect(taxYear)}
      data-testid={`annual-card-${taxYear}`}
    >
      <div className="p-4">
        {/* Year Header */}
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-amber-400" />
            <p className="font-bold text-white text-lg">{taxYear}</p>
          </div>
          <Badge variant="outline" className="border-slate-600 text-slate-400 text-xs">
            Tax Year
          </Badge>
        </div>

        {/* Earnings - Prominent */}
        <div className="mb-3">
          <p className={`text-3xl font-bold tracking-tight ${totalEarnings > 0 ? 'text-amber-400' : 'text-slate-600'}`}>
            £{totalEarnings.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </p>
        </div>

        {/* Stats Row */}
        <div className="flex items-center gap-3 text-xs text-slate-400">
          {tripCount > 0 && (
            <span className="flex items-center gap-1">
              <Ship className="h-3 w-3" />
              {tripCount} trip{tripCount !== 1 ? 's' : ''}
            </span>
          )}
          <span className="flex items-center gap-1">
            <TrendingUp className="h-3 w-3" />
            {monthsWithEarnings}/12 months
          </span>
        </div>
      </div>
    </div>
  );
};

export default AnnualBreakdownRow;
